import {
  ADD_SYSTEM_CONFIGURATION,
  GET_SYSTEM_CONFIGURATION,
  ALL_SYSTEM_CONFIGURATION,
  EDIT_SYSTEM_CONFIGURATION,
  UPLOAD_FILE,
  DOWNLOAD_FILE,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  data: null,
}

const SystemConfiguration = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SYSTEM_CONFIGURATION:
    case GET_SYSTEM_CONFIGURATION:
      state = {
        ...state,
        loading: true,
      }
      break 
    case ALL_SYSTEM_CONFIGURATION:
      state = {
        ...state,
        loading: false,
        data: action.payload.data,
      }
      break
    case EDIT_SYSTEM_CONFIGURATION:
      case UPLOAD_FILE:
        case DOWNLOAD_FILE:
      state = {
        ...state,
        loading: false,
      }
      break
    default:
      break
  }
  return state
}

export default SystemConfiguration
